import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { DebtsComponent } from 'shared/modules/debts/debts/debts.component';
import { LayoutModule } from 'shared/modules/layout/layout.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { TypographyModule } from 'shared/modules/typography/typography.module';
import { DebtsRowComponent } from './debts-row/debts-row.component';

@NgModule({
  declarations: [
    DebtsRowComponent,
    DebtsComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TypographyModule,
    NgxChartsModule,
    LayoutModule,
    TranslateModule,
    AngularModule,
  ],
  exports: [
    DebtsComponent,
  ],
})
export class DebtsModule {
}
